import React, { useEffect, useState } from "react";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import { Input } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Apiurl from "../../Apiurl";
import Button from "react-bootstrap/Button";
import { Tabhelper } from "../../Helper/Tabhelper";
import Bankoption from "../../Options/Bankoption";

export default function Products() {
  const [jsonList, setJsonList] = useState([]);

  const [show, setShow] = useState(false);
  const [uid, setuid] = useState("");
  const [upname, setupname] = useState("");
  const [updescription, setupdescription] = useState("");
  const [dataid, setdataid] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = async (id) => {
    try {
      const response = await axios.get(apiurl + `productscbc/${id}/`);
      setuid(response.data.productid);
      setupdescription(response.data.name);
      setupname(response.data.description);
      setdataid(response.data.id);
      setShow(true);
    } catch (error) {
      console.error(error);
    }
  };
  const handleupdate = async () => {
    const formdata = {
      productid: uid,
      name: upname,
      description: updescription,
    };
    // console.log(formdata);
    try {
      const response = await axios.patch(
        apiurl + `productscbc/${dataid}/`,
        formdata
      );
      alert("Data Updated...!");
      GetIncomeData();

      GetBillNoData();
      GetIncomeData();
      setuid("");
      setupdescription("");
      setupname("");
      setdataid("");
      setShow(false);
    } catch (error) {
      console.error(error);
      alert("Some Error occured\nTry again Later");
    }
  };
  //
  const apiurl = Apiurl();
  const usertype = window.localStorage.getItem("usertype");
  const { user } = useParams();

  const navigate = useNavigate();
  const [nameofpayer, setnameofpayer] = useState("");
  const [billno, setbillno] = useState("");
  const [remarks, setremarks] = useState("None");
  const [incomedata, setincomedata] = useState([]);

  const handleSubmit = async () => {
    const formdata = {
      productid: billno,
      name: nameofpayer,
      description: remarks,
    };
    // console.log(formdata);
    try {
      const response = await axios.post(apiurl + "productscbc/", formdata);
      alert("Expense Bill added");
      GetIncomeData();

      GetBillNoData();
      GetIncomeData();
      setnameofpayer("");
      setremarks("");
    } catch (error) {
      console.error(error);
      alert("Some Error occured\nTry again Later");
    }
  };
  async function GetBillNoData() {
    try {
      const responseth = await axios.get(apiurl + "productscbc/");

      setbillno("P" + (responseth.data.length + 1).toString().padStart(4, "0"));
    } catch (error) {
      console.error(error);
    }
  }
  async function GetIncomeData() {
    try {
      const response = await axios.get(apiurl + "productscbc/");
      setincomedata(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    GetBillNoData();
    GetIncomeData();
  }, []);

  //
  const initialData = {
    name: "Product",
    link: "/product",
    active: "no",
  };
  // useEffect to add initial data to the JSON list
  useEffect(() => {
    Tabhelper(initialData, setJsonList);
  }, []);

  const Tablecomp = (props) => {
    const [data, setData] = useState(props.data.slice(0).reverse());

    const [postsPerPage, setPostsPerPage] = useState(3);
    const [currentPage, setCurrentPage] = useState(1);
    const showData = () => {
      const indexOfLastPage = currentPage * postsPerPage;
      const indexOfFirstPage = indexOfLastPage - postsPerPage;
      const currentPosts = data.slice(indexOfFirstPage, indexOfLastPage);
      try {
        return currentPosts.map((item, index) => (
          <tbody key={index}>
            <tr>
              <td>{postsPerPage * (currentPage - 1) + index + 1}</td>

              <td>{item.productid}</td>
              <td>{item.name}</td>
              <td>{item.description}</td>
              <td>
                <Button
                  size="sm"
                  variant="outline-warning"
                  onClick={() => {
                    handleShow(item.id);
                  }}
                >
                  Update
                </Button>
              </td>
            </tr>
          </tbody>
        ));
      } catch (e) {
        alert(e.message);
      }
    };

    const showPagination = () => {
      const pageNumbers = [];
      const totalPosts = data.length;

      for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
        pageNumbers.push(i);
      }

      const renderPageNumbers = pageNumbers.slice(
        Math.max(0, currentPage - 2),
        Math.min(currentPage + 1, pageNumbers.length)
      );

      return (
        <nav>
          <ul className="pagination">
            {usertype === "Superuser" ? (
              <li className="page-item">
                <button
                  onClick={() => {
                    navigate(`/billapprove/allexpense/1/${user}`);
                  }}
                  className="page-link"
                >
                  Approve All
                </button>
              </li>
            ) : (
              <></>
            )}

            <li className="page-item">
              <button
                onClick={() => setCurrentPage(1)}
                className="page-link"
                disabled={currentPage === 1}
              >
                {"<<"}
              </button>
            </li>
            <li className="page-item">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                className="page-link"
                disabled={currentPage === 1}
              >
                {"<"}
              </button>
            </li>
            {renderPageNumbers.map((number) => (
              <li
                key={number}
                className={
                  currentPage === number ? "page-item active" : "page-item"
                }
              >
                <button
                  onClick={() => setCurrentPage(number)}
                  className="page-link"
                >
                  {number}
                </button>
              </li>
            ))}
            <li className="page-item">
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                className="page-link"
                disabled={currentPage === Math.ceil(totalPosts / postsPerPage)}
              >
                {">"}
              </button>
            </li>
            <li className="page-item">
              <button
                onClick={() =>
                  setCurrentPage(Math.ceil(totalPosts / postsPerPage))
                }
                className="page-link"
                disabled={currentPage === Math.ceil(totalPosts / postsPerPage)}
              >
                {">>"}
              </button>
            </li>
          </ul>
        </nav>
      );
    };

    return (
      <div className="container">
        <table className="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              {/* Sno	Bill no	Date	Amount Paid	Mode	Bill Status	Actions */}
              <th>Sno</th>
              <th>ID</th>
              <th>Name</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          {showData()}
        </table>

        <div style={{ float: "right" }}>{showPagination()}</div>
      </div>
    );
  };

  return (
    <Maincomponent tabname={"Product"}>
      <div className="component-sub">
        <div className="component-sub1">
          <div className="multistephead">
            <b>PRODUCTS</b>
          </div>
          <br />
          <div className="Billcompmain">
            {/* <div className="Billcompmain1"></div> */}
            <div className="Billcompmain2">
              {" "}
              <div className="multistepcontainer1">
                <div className="multistepsubcontainer1">
                  <div className="multisteptable">
                    {/*  */}
                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Product Id</div>
                      <div className="multisteptablecell2">
                        <Input
                          type="text"
                          disabled
                          value={billno}
                          onChange={(e) => {
                            setbillno(e.target.value);
                          }}
                          className="textipbill"
                        />
                      </div>
                    </div>

                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Name</div>
                      <div className="multisteptablecell2">
                        <Input
                          type="text"
                          value={nameofpayer}
                          onChange={(e) => {
                            setnameofpayer(e.target.value);
                          }}
                          className="textipbill"
                        />
                      </div>
                    </div>

                    <div className="multisteptablerow">
                      <div className="multisteptablecell1">Description</div>
                      <div className="multisteptablecell2">
                        <Input
                          type="text"
                          onChange={(e) => {
                            setremarks(e.target.value);
                          }}
                          value={remarks}
                          className="textipbill"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="multistepcontainerbtn">
                <button className="buttoncompnent1" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="Billcompmain">
            <Tablecomp data={incomedata} />
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {" "}
            <div className="multistepcontainer1">
              <div className="multistepsubcontainer1">
                <div className="multisteptable">
                  {/*  */}
                  <div className="multisteptablerow">
                    <div className="multisteptablecell1"> Id</div>
                    <div className="multisteptablecell2">
                      <Input
                        type="text"
                        disabled
                        value={uid}
                        onChange={(e) => {
                          setuid(e.target.value);
                        }}
                        className="textipbill"
                      />
                    </div>
                  </div>

                  <div className="multisteptablerow">
                    <div className="multisteptablecell1">Name</div>
                    <div className="multisteptablecell2">
                      <Input
                        type="text"
                        value={upname}
                        onChange={(e) => {
                          setupname(e.target.value);
                        }}
                        className="textipbill"
                      />
                    </div>
                  </div>

                  <div className="multisteptablerow">
                    <div className="multisteptablecell1">Description</div>
                    <div className="multisteptablecell2">
                      <Input
                        type="text"
                        onChange={(e) => {
                          setupdescription(e.target.value);
                        }}
                        value={updescription}
                        className="textipbill"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleupdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </Maincomponent>
  );
}
